import * as fb from 'js/facebook'
import { authenticateWithService } from './authenticateWithService'

export const loginWithFacebook = () => {
  return fb.login().then(({ token }) => {
    return fb.getUserDetails().then(({ email }) => {
      return authenticateWithService('facebook', { token, email })
    })
  })
}
